import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as userAction from "../Store/_redux/UserStore/userActions";
import * as leaveAction from "../Store/_redux/LeaveStore/leaveAction";
import UserCard from "../components/UserCard";

export default function UserList() {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth?.loginUser);
  const users = useSelector((state) => state.user?.users?.users || []);

  // Kullanıcıları sadece ilk yüklemede getir
  useEffect(() => {
    dispatch(userAction.getUsers());
  }, [dispatch]);

  // Auth geldiğinde izinleri getir
  useEffect(() => {
    if (auth) dispatch(leaveAction.getLeave(auth));
  }, [auth, dispatch]);

  return (
    <div className="flex flex-col w-[600px] mx-auto py-[30px]">
      <h1 className="font-semibold text-2xl py-5">
        Mevcut Kullanıcılar
      </h1>

      {users.length > 0 ? (
        users.map((user, i) => (
          <UserCard
            key={user._id || user.id || i}
            user={user}
            index={i}
            refresh={() => dispatch(userAction.getUsers())}
          />
        ))
      ) : (
        <p className="text-center text-gray-500">Henüz kullanıcı bulunamadı.</p>
      )}
    </div>
  );
}
